import React, { useState } from 'react'

import { Map } from 'immutable'
import { Field, reduxForm } from 'redux-form/immutable'

import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import TextArea from '@lyrahealth-inc/ui-core/lib/atoms/form/textArea/TextArea'
import { SelectFieldRFF } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/SelectField'

import { paymentRejectionReasons } from '../../../constants/appConstants'
import HiddenField from '../HiddenField'

const rejectionOptions = [
  ...Object.keys(paymentRejectionReasons).map((reason) => ({ label: reason, value: reason })),
  { label: 'Other', value: 'other' },
]

const RejectPaymentForm: React.FC<RejectPaymentFormProps> = ({
  initialValues,
  showRejectText,
  submitting,
  submitFunction,
  handleSubmit,
}) => {
  const [rejectionReason, setRejectionReason] = useState(initialValues?.get('description') || '')
  const [rejectionReasonTextArea, setRejectionReasonTextArea] = useState(
    initialValues?.get('description_text_area') || '',
  )

  return (
    // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'FormEventHa... Remove this comment to see the full error message
    <form onSubmit={handleSubmit(submitFunction)}>
      {showRejectText && (
        <div>
          <h3>
            <strong>Reject Payment</strong>
          </h3>
          <p>Please select the reason for rejecting the payment</p>
        </div>
      )}
      <Field name='charge_id' type='hidden' component={HiddenField} />
      <Field
        name='description'
        // @ts-expect-error TS(2769): react-final-form's FieldRenderProps vs redux-form's WrappedFieldProps
        component={SelectFieldRFF}
        options={rejectionOptions}
        placeholder='Select'
        onChange={(_event: React.ChangeEvent<any>, value: string) => {
          if (value !== 'other' && rejectionReasonTextArea) {
            setRejectionReasonTextArea('')
          }
          setRejectionReason(value)
        }}
      />
      {rejectionReason === 'other' && (
        <Field
          name='description_text_area'
          component={TextArea}
          onChange={(e: any) => setRejectionReasonTextArea(e.target.value)}
          placeholder='Reason for rejecting payment'
        />
      )}
      <DefaultButton
        id='requestreject-submit'
        type='submit'
        isLoading={submitting}
        disabled={
          !(rejectionReason && rejectionReason !== 'other') && !(rejectionReason === 'other' && rejectionReasonTextArea)
        }
      >
        {showRejectText ? 'Reject Payment' : 'Submit Comment'}
      </DefaultButton>
    </form>
  )
}

type RejectPaymentFormProps = {
  initialValues: Map<string, any>
  showRejectText: boolean
  submitting: boolean
  handleSubmit: (submitFunction: () => void) => void
  submitFunction: () => void
}

export default reduxForm({
  form: 'rejectPaymentForm',
  touchOnBlur: false,
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'FC<RejectPaymentFormProps>' is n... Remove this comment to see the full error message
})(RejectPaymentForm)
